(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["temperatura-luminarias"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('lamp-temperature-demo')) {
  customElements.define('lamp-temperature-demo', class extends HTMLElement {
    connectedCallback() {
      if (this._lampClick) return;
      this._media = window.matchMedia('(max-width:600px)');
      this._lampClick = (event) => {
        if (event.target.closest('lamp-temperature-demo') !== this) return;
        const choice = event.target.closest('.ltd__choice');
        const cards = Array.from(this.querySelectorAll('.ltd__item'));
        if (choice) {
          const index = Number(choice.dataset.ltdIndex);
          cards.forEach((card, i) => {
            card.classList.toggle('ltd__item--selected', i === index);
            card.querySelector('.ltd__switch').setAttribute('aria-pressed', String(i === index));
          });
          this.querySelectorAll('.ltd__choice').forEach((button) => button.setAttribute('aria-pressed', String(button === choice)));
          this._syncPower();
          return;
        }
        let button = event.target.closest('.ltd__switch');
        if (event.target.closest('.ltd__power')) button = this.querySelector('.ltd__item--selected .ltd__switch');
        if (!button) return;
        button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
        this._syncPower();
      };
      this._syncPower = () => {
        const current = this.querySelector('.ltd__item--selected .ltd__switch');
        const power = this.querySelector('.ltd__power');
        if (power && current) power.setAttribute('aria-pressed', current.getAttribute('aria-pressed'));
        // Hidden temperature text still gives the mobile image-button a stable accessible name.
        this.querySelectorAll('.ltd__switch').forEach((button) => {
          const hidden = this._media.matches && !button.closest('.ltd__item').classList.contains('ltd__item--selected');
          button.tabIndex = hidden ? -1 : 0;
          button.closest('.ltd__item').setAttribute('aria-hidden', String(hidden));
          if (this._media.matches) button.setAttribute('aria-label', button.querySelector('.ltd__temperature').textContent.trim());
          else button.removeAttribute('aria-label');
        });
      };
      this._modeChange = () => {
        if (this._media.matches) {
          this.querySelectorAll('.ltd__item:not(.ltd__item--selected) .ltd__switch').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        }
        this._syncPower();
      };
      this.addEventListener('click', this._lampClick);
      this._media.addEventListener('change', this._modeChange);
      this._frame = requestAnimationFrame(this._modeChange);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      this.removeEventListener('click', this._lampClick);
      this._media.removeEventListener('change', this._modeChange);
      this._lampClick = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
